/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProductMappingRequest } from '../../models/create-product-mapping-request';
import { ProductMappingRequestModel } from '../../models/product-mapping-request-model';

export interface CreateProductMappingFromRequest$Params {
  productMappingRequestId: string;
      body: CreateProductMappingRequest
}

export function createProductMappingFromRequest(http: HttpClient, rootUrl: string, params: CreateProductMappingFromRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingRequestModel>> {
  const rb = new RequestBuilder(rootUrl, createProductMappingFromRequest.PATH, 'post');
  if (params) {
    rb.path('productMappingRequestId', params.productMappingRequestId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/problem+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductMappingRequestModel>;
    })
  );
}

createProductMappingFromRequest.PATH = '/product-mappings/request/{productMappingRequestId}/create-product-mapping';
